import React, { useEffect, useState } from "react";
import Page_Header from "../General/Page_Header";
import "./GeneralReports.css";
import NoInternet from "../General/NotPermission/NoInternet";
import External_In_Map from "../External_Visites/External_In_Map";
import { useSelectorCustom } from "../General/GeneralComponent/useSelectorCustom";
import { AbstructVar } from "../General/GeneralComponent/AbstructVar";
import { AbstructLang } from "../General/GeneralComponent/AbstructLang";
import { ColumnArrayReports, VariableReports } from "./VariableReports";
import OrdersReqsReport from "./OrdersReqsReport";
import ObjectionsReport from "./ObjectionsReport";
import OrdersReport from "./OrdersReport";
import TargetGroupReport from "./TargetGroupReport";
import AllVisits from "./AllVisits";
import FreeSamplesReport from "./FreeSamplesReport";
import FreeSamplesTargetReport from "./FreeSamplesTargetReport";
import MarketingToolsReport from "./MarketingToolsReport";
import ReportsSidebar from "./ReportsSidebar";
import ProductsSalesReport from "./ProductsSalesReport";
import MedicalRepTargetReport from "./MedicalRepTargetReport";
import Page_General_Statistics from "../Main/CardsMain/Page_General_Statistics";
import { useDispatch } from "react-redux";
import Main from "../Main/Main";
import TargetGroupReportWithDate from "./TargetGroupReportWithDate";
import  Hospital  from "./Hospital";
import StockProduct  from "./StockProduct";
import StockMarkiting from "./StockMarkiting";
import InventoryBalanceCard from "./InventoryBalanceCard";
import MainWithSearch from "../Main/MainWithSearch";
import ReportTemplates from "./ReportTemplates";
import SmartCardsPanel from "./SmartCardsPanel";
import BatchExportButton from "./BatchExportButton";
import ScheduledReports from "./ScheduledReports";
import DashboardBuilder from "./DashboardBuilder";
import { logReportAccess } from "../../Redux/Actions/ActionStatistics";
function GeneralReports() {
  const [openInternet, setopenInternet] = useState(false);
  const [actionsCollapsed, setActionsCollapsed] = useState(() => {
    try { return localStorage.getItem("miamed_actions_collapsed") === "1"; } catch { return false; }
  });
  const { navigate, langmiamed } = AbstructVar();
  const { translate } = AbstructLang();
  const dispatch = useDispatch();
  const { state, storeMap, setIsTap, setIsOpen } = VariableReports();

  /* Phase 3 — batch export report list (subset that supports batch) */
  const BATCH_REPORTS = [
    { key: "marketing_tools_report", label: translate("marketing_tools_report") },
    { key: "free_samples_summarized_report", label: translate("free_samples_summarized_report") },
    { key: "free_samples_detailed_report", label: translate("free_samples_detailed_report") },
    { key: "hospital", label: translate("hospital") },
    { key: "get_products_stock_report", label: translate("get_products_stock_report") },
    { key: "get_markitings_stock_report", label: translate("get_markitings_stock_report") },
  ];

  const handleSelectReport = (key) => {
    setIsTap(key);
    dispatch(logReportAccess(key));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    /* Accept a report hand-off from the dashboard smart cards (FE-12) */
    let pending = null;
    try {
      pending = localStorage.getItem("miamed_pending_report");
      localStorage.removeItem("miamed_pending_report");
    } catch {}
    const initialReport = pending || "visits_frequeny_report";
    setIsTap(initialReport);
    if (pending) {
      dispatch(logReportAccess(pending));
    }
  }, []);
  const ReportComponents = {
    visits_frequeny_report: <TargetGroupReport />,
    target_visits_report: <AllVisits />,
    hospital: <Hospital />,
    target_visits_report_with_date: <TargetGroupReportWithDate />,
    free_samples_summarized_report: <FreeSamplesReport />,
    free_samples_detailed_report: <FreeSamplesTargetReport />,
    marketing_tools_report: <MarketingToolsReport />,
    monthly_orders_request_report: <OrdersReqsReport />,
    objection_rebort: <ObjectionsReport />,
    monthly_orders_report: <OrdersReport />,
    products_monthly_salesReport: <ProductsSalesReport />,
    medical_rep_target_report: <MedicalRepTargetReport />,
    get_products_stock_report: <StockProduct />,
    get_markitings_stock_report: <StockMarkiting />,
    inventory_balance_card: <InventoryBalanceCard />,
    // statistics: (
    //   <Main
    //     isDashboardPage={false}
    //     langmiamed={langmiamed}
    //     dispatch={dispatch}
    //     translate={translate}
    //   />
    // ),
    statisticsWithSearch: (
      <MainWithSearch
        isDashboardPage={false}
        langmiamed={langmiamed}
        dispatch={dispatch}
        translate={translate}
      />
    ),
  };
  return (
    <>
      <div
        className={langmiamed == "ar" ? "main-content_ar" : "main-content_en"}
      >
        <main>
          <Page_Header
            langmiamed={langmiamed}
            header={translate("reports")}
            path={`${translate("home")} / ${translate("reports")} `}
          />
        </main>
        <div className="page-content">
          {/* Top toolbar: Smart Cards + Action buttons */}
          <div className="reports-top-bar">
            <SmartCardsPanel
              onSelect={handleSelectReport}
              activeReport={state.isTap}
              translate={translate}
            />

            {/* Collapsible actions bar */}
            <div className={`reports-actions-wrapper${actionsCollapsed ? " collapsed" : ""}`}>
              <div
                className="reports-actions-toggle"
                onClick={() => {
                  const next = !actionsCollapsed;
                  setActionsCollapsed(next);
                  try { localStorage.setItem("miamed_actions_collapsed", next ? "1" : "0"); } catch {}
                }}
              >
                <span className="las la-cog"></span>
                <span>{translate("actions_tools")}</span>
                <span className={`las ${actionsCollapsed ? "la-angle-down" : "la-angle-up"}`}></span>
              </div>
              {!actionsCollapsed && (
                <div className="reports-actions-bar">
                  <ScheduledReports translate={translate} />
                  <DashboardBuilder translate={translate} />
                  <BatchExportButton
                    availableReports={BATCH_REPORTS}
                    translate={translate}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="reports-layout">
            <ReportsSidebar
              activeReport={state.isTap}
              onSelect={handleSelectReport}
              translate={translate}
              langmiamed={langmiamed}
            />
            <div className="reports-content">
              {/* FE-11 — Report Templates (save/load filter presets, collapsible) */}
              <ReportTemplates
                reportKey={state.isTap}
                filters={{}}
                onApply={(f) => {
                  // Templates apply filters — individual reports can consume this
                }}
                translate={translate}
              />
              {ReportComponents[state.isTap] &&
                React.cloneElement(ReportComponents[state.isTap], {
                  langmiamed,
                  t: translate,
                  setopenInternet,
                  navigate,
                })}
            </div>
          </div>
        </div>
      </div>
      {openInternet && (
        <NoInternet open={openInternet} setOpen={setopenInternet} />
      )}
      {state.openMap && (
        <External_In_Map
          open={state.openMap}
          setOpen={setIsOpen}
          lat={state.lat}
          lng={state.lng}
        />
      )}
    </>
  );
}

export default GeneralReports;
